import React from "react";

import { Button, Col } from "reactstrap";

// reactstrap components
import { Container } from "reactstrap";

export default function PageHeader() {
  const scrollToDownload = () => {
    document
      .getElementById("examples-section")
      .scrollIntoView({ behavior: "smooth" });
  };
  return (
    <div className="page-header header-filter">
      <div className="squares square1" />
      <div className="squares square2" />
      <div className="squares square3" />
      <div className="squares square4" />
      <div className="squares square5" />
      <div className="squares square6" />
      <div className="squares square7" />
      <Container>
        <div className="content-center brand">
          <h1 className="h1-seo">9.maj turnir</h1>
          <p>
            Učestvuj u prvom humanitarnom gejming turniru gimnazije "9. maj" u
            Nišu koji organizuju učenici speciojalizovanih IT odeljenja!
            <br /> Igrice u kojima se ove godine takmičimo su sledeće: <br />
            LOL (League of legends), CS:GO (Counter-Strike: Global Offensive)
          </p>
          <Button
            className="btn-round"
            color="info"
            href=""
            role="button"
            size="lg"
            onClick={scrollToDownload}
          >
            Prijava
          </Button>
        </div>
      </Container>
    </div>
  );
}
